export default "__VITE_ASSET__dd4aeb48__"